import { Form, TextFieldControl, useToast, VALIDATION } from '@foxtaibox/foxtailbox-frontend-core';
import { useSendBugReportMutation } from '@generated/graphql';
import { Button, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { BugReportFormInputs } from './types';

interface BugReportFormProps {
  onCancel: () => void;
}

const BugReportForm = ({ onCancel }: BugReportFormProps) => {
  const { t } = useTranslation();
  const { showSuccessToast, showErrorToast } = useToast();
  const form = useForm<BugReportFormInputs>({ defaultValues: { topic: '', description: '' } });
  const { handleSubmit } = form;
  const [sendBugReport, { loading }] = useSendBugReportMutation();

  const onSubmit = (formData: BugReportFormInputs) => {
    sendBugReport({ variables: { input: formData } })
      .then((res) => {
        if (res.data?.sendBugReport) {
          showSuccessToast(t('assessment.bugReport.success'));
          onCancel();
        } else {
          showErrorToast(t('errors.common'));
        }
      })
      .catch(() => showErrorToast(t('errors.common')));
  };

  return (
    <Form form={form}>
      <Stack spacing={3} mb={3}>
        <TextFieldControl
          name='topic'
          label={t('assessment.bugReport.topic')}
          placeholder={t('assessment.bugReport.topic')}
          type='text'
          rules={{ required: true, ...VALIDATION({}).fullUserName }}
        />
        <TextFieldControl
          name='description'
          label={t('assessment.bugReport.description')}
          placeholder={t('assessment.bugReport.descriptionPlaceholder')}
          type='text'
          rules={{ required: true, ...VALIDATION({}).companyName }}
          multiline
          rows={5}
        />
      </Stack>
      <Stack direction='row' spacing={2} justifyContent='flex-end'>
        <Button onClick={onCancel} color='secondary'>
          {t('cancel')}
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          loading={loading}
          color='primary'
          variant='contained'>
          {t('confirm')}
        </Button>
      </Stack>
    </Form>
  );
};

export default BugReportForm;
